<script lang="ts">
import type { SetupContext } from 'vue';
import { defineComponent } from 'vue';
import type { HekateDisplayField } from '@onshape/www-inertia';
import FieldUtil from './FieldUtil';

export default defineComponent({
  props: {
    field: {
      required: true,
      type: Object as unknown as () => HekateDisplayField,
    },
    modelValue: {
      required: true,
      type: [String, Boolean, Number],
    },
  },
  setup(props: { modelValue: string | boolean; field: HekateDisplayField }, context: SetupContext) {
    const bubbleModel = FieldUtil.bubbleModel({
      get: () => props.modelValue,
      emitter: context,
    });

    return {
      bubbleModel,
    };
  },
});
</script>

<template>
  <input
    v-model="bubbleModel"
    type="hidden"
    :html-name="field.htmlName"
  />
</template>

<style lang="scss" scoped></style>
